import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { MapPin, History, Bell, Menu } from "lucide-react";
import api from "@/lib/api";

export default function MobileTabBar({ onMenu, onCloseMenu, menuOpen }) {
  const nav = useNavigate();
  const loc = useLocation();
  const [unread, setUnread] = useState(0);
  const [sos, setSos] = useState(false);

  useEffect(() => {
    let stop = false;
    const load = () =>
      api.get("/alerts?acknowledged=false&limit=200").then((r) => {
        if (stop) return;
        const list = r.data || [];
        setUnread(list.length);
        setSos(list.some((a) => a.type === "sos"));
      }).catch(() => {});
    load();
    const id = setInterval(load, 30000);
    return () => { stop = true; clearInterval(id); };
  }, [loc.pathname]);

  const tabs = [
    { id: "carte", label: "Carte", Icon: MapPin, to: "/dashboard" },
    { id: "historique", label: "Historique", Icon: History, to: "/historique" },
    { id: "alertes", label: "Alertes", Icon: Bell, to: "/alertes", badge: unread },
    { id: "menu", label: "Menu", Icon: Menu, action: onMenu },
  ];

  const isActive = (t) => {
    if (t.action) return menuOpen;
    if (t.to === "/dashboard") return loc.pathname === "/dashboard" || loc.pathname === "/";
    return loc.pathname.startsWith(t.to);
  };

  return (
    <nav data-testid="mobile-tabbar"
      className="fixed bottom-0 left-0 right-0 z-[600] flex items-center justify-around h-16 pb-[env(safe-area-inset-bottom,8px)] bg-[#121214]/95 backdrop-blur-xl border-t border-white/10 shadow-[0_-4px_20px_rgba(0,0,0,0.6)]">
      {tabs.map((t) => {
        const active = isActive(t);
        return (
          <button key={t.id} data-testid={`mobile-tab-${t.id}`}
            onClick={() => (t.action ? t.action() : (onCloseMenu && onCloseMenu(), nav(t.to)))}
            className={`relative flex flex-col items-center justify-center gap-1 flex-1 h-full transition-colors duration-150 ${active ? "text-[#F5821F] font-semibold" : "text-zinc-400 hover:text-zinc-200"}`}>
            <t.Icon className="w-5 h-5" />
            <span className="text-[10px]">{t.label}</span>
            {t.badge > 0 && (
              <span data-testid="mobile-tab-alertes-badge"
                className={`absolute top-1.5 right-[calc(50%-20px)] min-w-[16px] h-4 px-1 rounded-full text-[9px] font-bold text-white flex items-center justify-center ${sos ? "bg-[#DC2626] animate-pulse" : "bg-[#F5821F]"}`}>
                {t.badge > 99 ? "99+" : t.badge}
              </span>
            )}
          </button>
        );
      })}
    </nav>
  );
}
